// @flow

import React, { type Node } from 'react';
import brandVrSrc from './brand-vr.svg';

export function CardBrand(props: CardBrandProps): Node {
  const { cardBrand } = props;
  const cardBrandSrc = getBrandSource(cardBrand);

  if (!cardBrandSrc) {
    return null;
  }

  return (
    <img
      alt={cardBrand}
      src={cardBrandSrc}
      style={{
        height: '20px',
        position: 'absolute',
        top: '50%',
        marginTop: '-10px',
        right: '0.5em',
        pointerEvents: 'none',
      }}
    />
  );
}

type CardBrandProps = {
  cardBrand: string,
};

function getBrandSource(cardBrand: string): ?string {
  switch (cardBrand) {
    case 'vr':
      return brandVrSrc;
    default:
      return null;
  }
}
